"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useColor;
var _theme = require("@veneer/theme");
// check if the color is a semantics color
function isSemanticsColor(color) {
  return Object.keys(_theme.color.light).includes(color) && !['foreground', 'background', 'stroke', 'focus'].includes(color);
}

// check if the color is inside color object (token or semantics)
function isColorObject(color, theme) {
  return Object.keys(theme.color).includes(color);
}

/**
 * Hook to receive a color (string, token, semantics) and check how to return default value.
 * @returns {string} color
 */
function useColor(color) {
  var theme = (0, _theme.useTheme)();
  if (isSemanticsColor(color)) {
    return theme.color[color].base.default;
  }
  if (isColorObject(color, theme)) {
    return theme.color[color];
  }
  return color;
}